import { useState } from 'react';
import {
    Button,
    ComboTextField,
    GlanceLoader,
    Icon,
    Tooltip
  } from '../ui-components';
  import React from 'react';

function CameraShareState({onSend, onCancel=()=>{}, showCancel = true, minPhoneLength = 10, onVisitorOn = ()=>{}, onVisitorOff = ()=>{}, gicon}) {

    const enterPhoneText = "Enter phone number";
    const [phone, setPhone] = useState(enterPhoneText);
    const [sendDisabled, setSendDisabled] = useState(true);


    function isTooShort(str) {
      return str === undefined || str === null || str.trim().length < minPhoneLength;
    }

    function sendHandler(event) {
        event.preventDefault();
        if (!sendDisabled) {
            (typeof(onSend) === typeof(Function)) ? onSend(phone) : console.log("Send button clicked.");
        }
    }
    
    function cancelHandler(event) {
        event.preventDefault();
        (typeof(onCancel) === typeof(Function)) ? onCancel() : console.log("Cancel button clicked.");
    }

    function keyChangeHandler(phoneNumber) {
        setPhone(phoneNumber);
        let invalidPhone = isTooShort(phoneNumber);
        setSendDisabled(invalidPhone);
    }

  let comboTextField = <ComboTextField
  size="large"
  id="TextInput"
  placeholder="Mobile #"
  shape="rounded-full"
  onChange={(e) => keyChangeHandler(e.target.value)}
  // named slots syntax slot[slotName in camelCase]
  slotIconLeft={<Icon name="phone" size="5.5" />}
  slotAction={
    <Tooltip text="Send SMS" offset={6} size="small">
      <Button
        size="small"
        variant="tertiary"
        disabled={sendDisabled}
        shape="rounded-full"
        onClick={sendHandler}
      >
        Send
      </Button>
    </Tooltip>
  }
/>

return (
    <>
      <div className="SizeWrapper">
      <div className="rowAlign">
        { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
        <div className="w-80 mb-25">
        <label htmlFor="TextInput" className="offsetAfterLoader inline-flSex items-center gap-1 relative antialiased rtl:text-right typography-body-medium-body20 text-neutral-on-surface-text-default pb-1.5" text="Camera Share">Camera Share</label>
          <div className='borderContainer'>
          {comboTextField}
          {showCancel && <span className='buttonSep'>&nbsp;</span>}
          {showCancel && (<Button
            size="medium"
            variant="secondary"
            shape="rounded-full"
            className="cancel"
            animation={false}
            outline={true}
            onClick={cancelHandler}
          >
            Cancel
          </Button>)}
        </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default CameraShareState;